import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import HistoricGraphs from './HistoricGraphs';
import { useMemo, useState } from 'react';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';

export default function HistoricTabs() {
  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Total Supply' },
      { key: 'supply_rate_apy', value: 'Supply APY' }
    ],
    []
  );
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');

  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );
  const [data, error] = useApi({
    url: `/morpho/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }
  let content;
  if (data) {
    content = (
      <HistoricGraphs
        data={data}
        timeFilter={timeFilter}
        chartDaysAgo={chartDaysAgo}
        activeDisplayOption={activeDisplayOption}
      />
    );
  } else {
    content = <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {content}
    </Flex>
  );
}
